<template>
  <section
    class="py-20 md:py-10 bg-surfaceSaturated rounded-t-3xl theme-transition border-t border-brand-darkblue"
  >
    <div class="mx-auto max-w-90dvw text-center">
      <div class="max-w-3xl mx-auto space-y-12">
        <h2 class="text-3xl min-md:text-4xl font-bold text-primary">
          {{ $t("mission.title") }}
        </h2>
        <p class="text-lg text-secondary text-balance">
          {{ $t("mission.description") }}
        </p>
        <router-link
          to="/our-mission"
          class="inline-block border border-brand-yellow bg-brand-darkblue px-4 py-3 rounded-lg text-white hover:text-brand-yellow focus:text-brand-yellow focus-visible:text-brand-yellow transition-colors duration-200"
          :aria-label="$t('mission.ctaAriaLabel')"
        >
          <span class="font-medium">{{ $t("mission.ctaText") }}</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scpoed></style>
